// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"08f02637","583":"adf9aed6","845":"6b10dc04","983":"fbc318b3"}[chunkId] + ".chunk.js";
};